// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__Zbpmd","inputWrap":"styles_inputWrap__3dfHN","input":"styles_input__3voDV"};